"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShoninshaName = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CTextField = _interopRequireDefault(require("01_core/components/materials/CTextField"));
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 承認者
 */
const ShoninshaName = props => {
  const {
    intl,
    shoninshaNm,
    onChange,
    error,
    helperText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_SHONINSHA
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CTextField.default, {
    value: shoninshaNm,
    onChange: onChange,
    maxLength: 60,
    error: !!error,
    helperText: helperText
  }));
};
exports.ShoninshaName = ShoninshaName;
var _default = exports.default = (0, _reactIntl.injectIntl)(ShoninshaName);